import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllEvaluationReviews } from '../../services/ExpertReviewService';

export default function AssignedPortfolios() {
  const [reviews, setReviews] = useState([]);
  const [search, setSearch] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    getAllEvaluationReviews()
      .then(setReviews)
      .catch(() => setError('Unable to load assigned student portfolios.'))
      .finally(() => setLoading(false));
  }, []);

  const students = useMemo(() => {
    const grouped = new Map();
    reviews.forEach((review) => {
      const current = grouped.get(review.student.uuid) || { ...review.student, reviews: [] };
      current.reviews.push(review);
      grouped.set(review.student.uuid, current);
    });
    const term = search.trim().toLowerCase();
    return [...grouped.values()].filter((student) =>
      !term || `${student.first_name} ${student.last_name} ${student.email}`.toLowerCase().includes(term),
    );
  }, [reviews, search]);

  return (
    <div className="mx-auto max-w-6xl space-y-5">
      <div>
        <h1 className="text-3xl font-bold">Assigned student portfolios</h1>
        <p className="text-gray-600 dark:text-gray-300">
          Portfolios are limited to manual information and approved results from interviews you are assigned to.
        </p>
      </div>
      <input
        aria-label="Search assigned students"
        value={search}
        onChange={(event) => setSearch(event.target.value)}
        placeholder="Search students"
        className="w-full rounded border p-3 text-gray-900 md:max-w-md"
      />
      {loading && <p role="status" className="text-gray-500">Loading assigned portfolios…</p>}
      {error && <p role="alert" className="text-red-600">{error}</p>}
      <div className="grid gap-4 md:grid-cols-2">
        {students.map((student) => (
          <article key={student.uuid} className="rounded-xl border bg-white p-5 shadow-sm dark:border-gray-700 dark:bg-gray-800">
            <h2 className="text-lg font-semibold">{student.first_name} {student.last_name}</h2>
            <p className="text-gray-600 dark:text-gray-300">{student.email}</p>
            <p className="mt-2 text-sm">{student.reviews.length} assigned interview review{student.reviews.length === 1 ? '' : 's'}</p>
            <button
              onClick={() => navigate(`/portfolio/${student.uuid}`)}
              className="mt-4 rounded bg-blue-600 px-4 py-2 font-medium text-white"
            >
              Open scoped portfolio
            </button>
          </article>
        ))}
      </div>
      {!loading && !students.length && !error && (
        <p className="rounded border border-dashed p-8 text-center text-gray-500">No assigned students match this search.</p>
      )}
    </div>
  );
}
